<template>
  <div class="pa-3 d-flex flex-column align-center _bg-default">
    <v-card pa-2 class="game">
      <v-toolbar color="indigo" class="mb-3" dense dark
        ><h3>Smara</h3>
        <v-spacer></v-spacer>
        <v-btn dark @click="HintSmara = true" text>Instruksi Game</v-btn>
      </v-toolbar>
      <!-- <v-row> -->
      <v-col cols="12" md="12" v-if="fromRoute">
        <v-btn
          color="indigo"
          dark
          class="ml-3"
          v-if="!isPlayed"
          @click="sendText"
          >Mulai Game</v-btn
        >
      </v-col>
      <v-col cols="12" md="12" class="ml-3">
        <unity
          src="/Smara/Build/smara.json"
          width="900"
          height="500"
          unityLoader="/Smara/Build/UnityLoader.js"
          ref="myInstance"
        ></unity>
      </v-col>
      <!-- </v-row> -->
    </v-card>
    <HintSmara v-bind:HintSmara="HintSmara" @false="closeDialog" />
  </div>
</template>

<script>
import Unity from "vue-unity-webgl";
import HintSmara from "../../components/_base/Game/HintSmara.vue";

export default {
  name: "Game",
  components: {
    Unity,
    HintSmara
  },
  data() {
    return {
      fromRoute: localStorage.getItem("from"),
      poin: 200,
      isPlayed: false,
      id: localStorage.getItem("id"),
      HintSmara: true,
      loading: false
    };
  },
  methods: {
    sendText() {
      this.$refs.myInstance.message(
        "gameManager",
        "StartGame",
        `${this.id},${this.fromRoute}`
      );
      this.isPlayed = true;
    },
    closeDialog() {
      this.HintSmara = false;
    }
  }
};
</script>

<style scoped>
._bg-default {
  background: #f4f6f9;
}
.game {
  width: max-content;
}
</style>
